import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["country", "region"]

  connect() {
    this.loadCountries()
  }

  async loadCountries() {
    try {
      const response = await fetch("/country_regions/countries")
      const countries = await response.json()

      this.countryTarget.innerHTML = `<option value="">Select a country</option>`

      const defaultValue = (this.countryTarget.dataset.defaultValue || "").toLowerCase()

      countries.forEach(({ code, name }) => {
        const option = document.createElement("option")
        option.value = code
        option.textContent = name

        if (defaultValue && (defaultValue === code.toLowerCase() || defaultValue === name.toLowerCase())) {
          option.selected = true
        }

        this.countryTarget.appendChild(option)
      })

      if (this.hasRegionTarget && this.countryTarget.value) {
        this.loadSubdivisions(this.countryTarget.value)
      }

      this.countryTarget.addEventListener("change", (e) => {
        if (this.hasRegionTarget) {
          if (e.target.value) {
            this.loadSubdivisions(e.target.value)
          } else {
            this.resetRegion()
          }
        }
      })
    } catch (error) {
      console.error("Failed to load countries", error)
    }
  }

  async loadSubdivisions(countryCode) {
    try {
      const response = await fetch(
        `/country_regions/subdivisions?country_name=${encodeURIComponent(countryCode)}`
      )

      if (!response.ok) {
        this.resetRegion()
        return
      }

      const subdivisions = await response.json()

      if (!Array.isArray(subdivisions)) {
        this.resetRegion()
        return
      }

      this.regionTarget.innerHTML = `<option value="">Select a region</option>`

      subdivisions.forEach(({ code, name }) => {
        const option = document.createElement("option")
        option.value = code
        option.textContent = name

        if (this.regionTarget.dataset.defaultValue === code) {
          option.selected = true
        }

        this.regionTarget.appendChild(option)
      })
    } catch (error) {
      console.error("Failed to load subdivisions", error)
      this.resetRegion()
    }
  }

  resetRegion() {
    if (this.hasRegionTarget) {
      this.regionTarget.innerHTML = `<option value="">Select a region</option>`
    }
  }
}

